import { z } from 'zod';

export const getColorCatalogsSchema = z.array(
  z.object({
    id: z.string(),
    name: z.string(),
    code: z.string(),
  })
);

export type GetColorCatalogs = z.infer<typeof getColorCatalogsSchema>;
